import '~/assets/sass/styles.sass'
import '~/assets/sass/general.sass'
import '~/assets/css/global.css'

export const onRouteUpdate = () => {
  // HubSpot chat targeting updates only on page load, so refresh on SPA navigation
  setTimeout(() => {
    if (window.HubSpotConversations?.widget) {
      window.HubSpotConversations.widget.refresh();
    } else {
      // if hubspot loads late
      window.HubSpotConversations?.widget?.load?.();
    }
  }, 300);
};

export const onClientEntry = () => {
  // Patch dataLayer and LinkedIn tracking
  window.dataLayer = window.dataLayer || [];
  const originalPush = window.dataLayer.push;

  window.dataLayer.push = function (event) {
    if (event?.event === "formSubmit" || event?.event === "selected_num_of_prop") {
      return;
    }
    return originalPush.apply(window.dataLayer, arguments);
  };

  window.lintrk = function () {
    return false;
  };

  // Remove the injected script before it runs
  const scriptObserver = new MutationObserver((mutations) => {
    for (let mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (
          node.tagName === "SCRIPT" &&
          node.textContent?.includes("#pricing-form") &&
          node.textContent?.includes("formSubmit")
        ) {
          node.parentNode?.removeChild(node);
        }
      });
    }
  });

  scriptObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // Remove any unwanted form event listeners if script ran too soon
  document.addEventListener("DOMContentLoaded", () => {
    const form = document.querySelector("#pricing-form");
    if (form && form.parentNode) {
      const clone = form.cloneNode(true);
      form.parentNode.replaceChild(clone, form);
    }
  });
};